/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/channel.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Channel
 */
export interface Channel {
    /**
     * @generated from protobuf field: optional string channel_id = 1;
     */
    channel_id?: string;
    /**
     * @generated from protobuf field: optional string network_id = 2;
     */
    network_id?: string;
    /**
     * @generated from protobuf field: optional string channel_name = 3;
     */
    channel_name?: string;
    /**
     * @generated from protobuf field: optional string channel_call_sign = 4;
     */
    channel_call_sign?: string;
    /**
     * @generated from protobuf field: optional string network_name = 5;
     */
    network_name?: string;
    /**
     * @generated from protobuf field: optional string provider = 6;
     */
    provider?: string;
    /**
     * @generated from protobuf field: optional string reporting_entity = 7;
     */
    reporting_entity?: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Channel$Type extends MessageType<Channel> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Channel", [
            { no: 1, name: "channel_id", kind: "scalar", localName: "channel_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Channel ID." } },
            { no: 2, name: "network_id", kind: "scalar", localName: "network_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "123", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Network ID." } },
            { no: 3, name: "channel_name", kind: "scalar", localName: "channel_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "ABC (WLS - Chicago, IL)", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Channel Name." } },
            { no: 4, name: "channel_call_sign", kind: "scalar", localName: "channel_call_sign", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "???", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Channel Call Sign." } },
            { no: 5, name: "network_name", kind: "scalar", localName: "network_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "FOX", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Network Name." } },
            { no: 6, name: "provider", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "FUBOSN_HD", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } },
            { no: 7, name: "reporting_entity", kind: "scalar", localName: "reporting_entity", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "ABC", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "???" } }
        ]);
    }
    create(value?: PartialMessage<Channel>): Channel {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Channel>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Channel): Channel {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string channel_id */ 1:
                    message.channel_id = reader.string();
                    break;
                case /* optional string network_id */ 2:
                    message.network_id = reader.string();
                    break;
                case /* optional string channel_name */ 3:
                    message.channel_name = reader.string();
                    break;
                case /* optional string channel_call_sign */ 4:
                    message.channel_call_sign = reader.string();
                    break;
                case /* optional string network_name */ 5:
                    message.network_name = reader.string();
                    break;
                case /* optional string provider */ 6:
                    message.provider = reader.string();
                    break;
                case /* optional string reporting_entity */ 7:
                    message.reporting_entity = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Channel, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string channel_id = 1; */
        if (message.channel_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.channel_id);
        /* optional string network_id = 2; */
        if (message.network_id !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.network_id);
        /* optional string channel_name = 3; */
        if (message.channel_name !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.channel_name);
        /* optional string channel_call_sign = 4; */
        if (message.channel_call_sign !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.channel_call_sign);
        /* optional string network_name = 5; */
        if (message.network_name !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.network_name);
        /* optional string provider = 6; */
        if (message.provider !== undefined)
            writer.tag(6, WireType.LengthDelimited).string(message.provider);
        /* optional string reporting_entity = 7; */
        if (message.reporting_entity !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.reporting_entity);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Channel
 */
export const Channel = new Channel$Type();
